// UI copy shared by the portal and public surveys. Customer content is never translated.
export const portalFR = {
  question_option_label: 'Option {{option}} de la question {{question}}',
  surveys: 'Questionnaires',
  survey: 'Questionnaire',
  listen_to_your_customers_and_assign_tags_after_submission:
    'Écoutez vos clients et attribuez des tags après l’envoi.',
  select_a_venue_to_manage_surveys:
    'Sélectionnez un établissement pour gérer les questionnaires.',
  create_survey: 'Créer un questionnaire',
  edit_survey: 'Modifier le questionnaire',
  search_surveys_by_name: 'Rechercher un questionnaire par nom',
  search_for_a_survey_by_name: 'Rechercher un questionnaire par nom…',
  no_surveys_found: 'Aucun questionnaire trouvé',
  create_your_first_survey_to_collect_feedback_and_ratings:
    'Créez votre premier questionnaire pour recueillir des avis et des notes.',
  published: 'Publié',
  paused_draft: 'En pause / brouillon',
  responses: 'Réponses',
  rating: 'Note',
  none_yet: 'Aucune pour le moment',
  customer_link: 'Lien client',
  surveys_2: 'questionnaires',
  questions: 'questions ·',
  tags: 'tags',
  responses_2: 'réponses',
  survey_saved: 'Questionnaire enregistré',
  save_survey: 'Enregistrer le questionnaire',
  write_your_questions_a_five_star_rating_is_always_included_at_the_end:
    'Rédigez vos questions. Une note sur cinq étoiles est toujours proposée à la fin.',
  survey_name: 'Nom du questionnaire *',
  e_g_how_was_your_dinner: 'Ex. Comment s’est passé votre dîner ?',
  introduction_for_the_customer: 'Introduction pour le client',
  tags_to_add_after_submission: 'Tags à ajouter après l’envoi',
  these_are_added_to_the_customer_s_tags_without_removing_existing_ones:
    'Ils s’ajoutent aux tags du client sans supprimer les tags existants.',
  loading_tags: 'Chargement des tags…',
  select_venue_tags: 'Sélectionnez les tags de l’établissement',
  question_and_answer_tags_are_not_yet_supported_by_the_connected_service_you_can_confi:
    'Le service connecté ne prend pas encore en charge les tags des questions et réponses. Vous pouvez les configurer ici, mais leur enregistrement nécessite une mise à jour du service.',
  question_and_answer_tags_require_an_update_to_the_connected_service_the_survey_was_no:
    'Les tags des questions et réponses nécessitent une mise à jour du service connecté. Le questionnaire n’a pas été enregistré.',
  enter_a_name_question_text_and_at_least_two_distinct_options_for_choice_questions:
    'Saisissez un nom, le texte des questions et au moins deux options distinctes pour les questions à choix.',
  question: 'Question',
  question_text: 'Texte de la question *',
  answer_type: 'Type de réponse',
  text_answer: 'Réponse libre',
  single_choice_one_answer: 'Choix unique — une réponse',
  multiple_choice_several_answers: 'Choix multiple — plusieurs réponses',
  question_tags: 'Tags de la question',
  added_when_the_customer_answers_this_question:
    'Ajoutés lorsque le client répond à cette question.',
  no_tags_for_this_question: 'Aucun tag pour cette question',
  answer_options_2_to_20: 'Options de réponse (de 2 à 20)',
  tags_when_the_customer_selects_this_answer:
    'Tags si le client choisit cette réponse',
  select_tags_for_this_answer: 'Sélectionnez les tags pour cette réponse',
  add_option: 'Ajouter une option',
  remove_option: 'Supprimer l’option',
  required_answer: 'Réponse obligatoire',
  add_question: 'Ajouter une question',
  move_question_up: 'Monter la question',
  move_question_down: 'Descendre la question',
  remove_question: 'Supprimer la question',
  final_rating_from_1_to_5_stars: 'Note finale de 1 à 5 étoiles',
  the_customer_selects_a_star_rating_before_submitting_the_survey:
    'Le client choisit une note avant d’envoyer le questionnaire.',
  publish_survey: 'Publier le questionnaire',
  when_disabled_links_no_longer_accept_responses_existing_responses_remain_saved:
    'Si désactivé, les liens n’acceptent plus de réponses. Les réponses déjà reçues sont conservées.',
  survey_preview: 'Aperçu du questionnaire',
  create_a_customer_link: 'Créer un lien pour un client',
  search_customers_by_name_email_or_code:
    'Recherchez un client par nom, e-mail ou code',
  type_at_least_2_characters: 'Saisissez au moins 2 caractères…',
  searching: 'Recherche en cours…',
  no_customers_found: 'Aucun client trouvé.',
  generate_customer_link: 'Générer le lien client',
  this_link_associates_the_response_with_the_selected_customer:
    'Ce lien associe la réponse au client sélectionné.',
  survey_link: 'Lien du questionnaire',
  link_copied: 'Lien copié',
  copy_the_link_manually_from_the_field_above:
    'Copiez manuellement le lien dans le champ ci-dessus.',
  loading_responses: 'Chargement des réponses…',
  you_have_not_received_any_responses_yet:
    'Vous n’avez pas encore reçu de réponses.',
  tags_added: 'Tags ajoutés :',
  the_request_could_not_be_completed: 'La demande n’a pas pu aboutir.',
  your_opinion_matters: 'Votre avis compte',
  the_link_is_incomplete_ask_the_venue_for_a_new_link:
    'Le lien est incomplet. Demandez un nouveau lien à l’établissement.',
  this_survey_is_unavailable_ask_the_venue_for_a_new_link:
    'Ce questionnaire n’est pas disponible. Demandez un nouveau lien à l’établissement.',
  we_could_not_load_the_survey_please_try_again:
    'Impossible de charger le questionnaire. Réessayez.',
  loading_failed: 'Échec du chargement.',
  the_survey_has_been_updated_please_review_the_questions:
    'Le questionnaire a été mis à jour. Vérifiez les questions.',
  check_your_answers_and_choose_a_rating_from_1_to_5_stars:
    'Vérifiez vos réponses et choisissez une note de 1 à 5 étoiles.',
  submission_failed_please_try_again_shortly:
    'Échec de l’envoi. Réessayez dans un instant.',
  submission_failed: 'Échec de l’envoi.',
  your_voice_helps_us_grow: 'Votre voix nous fait grandir',
  a_moment_to_listen: 'UN MOMENT POUR VOUS ÉCOUTER',
  your_feedback_makes_a_difference: 'Votre avis fait la différence.',
  preparing_your_survey: 'Préparation de votre questionnaire…',
  responses_sent: 'RÉPONSES ENVOYÉES',
  thank_you_for_your_feedback: 'Merci pour votre avis !',
  your_answers_have_been_recorded_thank_you_for_taking_the_time_to_help_us_improve:
    'Vos réponses ont été enregistrées. Merci d’avoir pris le temps de nous aider à nous améliorer.',
  tell_us_about_your_experience: 'Parlez-nous de votre expérience',
  answer_the_questions_and_leave_your_final_rating:
    'Répondez aux questions et donnez votre note finale.',
  your_answers_are_linked_to_your_customer_profile:
    'Vos réponses sont associées à votre fiche client.',
  powered_by: 'Réalisé avec',
  optional: ' (facultative)',
  write_your_answer_here: 'Écrivez votre réponse ici…',
  choose_one_answer: 'Choisissez une seule réponse.',
  you_can_choose_several_answers: 'Vous pouvez choisir plusieurs réponses.',
  how_would_you_rate_your_experience:
    'Comment évaluez-vous votre expérience ? *',
  choose_from_1_to_5_stars: 'Choisissez de 1 à 5 étoiles.',
  no_rating_selected: 'Aucune note sélectionnée',
  submit_your_feedback: 'Envoyer votre avis',
  text_answers_can_contain_up_to_5_000_characters:
    'Les réponses libres peuvent contenir jusqu’à 5 000 caractères.',
  choose_a_valid_answer: 'Choisissez une réponse valide.',
  choose_only_the_available_options:
    'Choisissez uniquement les options proposées.',
  choose_a_rating_from_1_to_5_stars: 'Choisissez une note de 1 à 5 étoiles.',
  complete_the_question_value: 'Répondez à la question : {{question}}',
  value_out_of_5_stars: '{{count}} sur 5 étoiles',
  value_stars: '{{count}} étoiles',
  value_questions_value_tags: '{{count}} questions · {{tags}} tags',
  value_responses: '{{count}} réponses',
  value_surveys: '{{count}} questionnaires',
  value_questions_rating: '{{count}} questions + note',
  responses_value: 'Réponses · {{name}}',
};
